/*eslint-disable no-undef*/
/*global translate*/
import { connect } from 'react-redux'
import React, { Component, memo } from 'react'
import { FixedSizeList as List, areEqual, shouldComponentUpdate } from 'react-window';

import GroupItem from './../group_item'
import TabChatFolders from './../tab_chat_folders'

// const { chooseGroupAction } = global.rootRequire('redux')
const { changeGroupFunc } = global.rootRequire('redux')
const { rxaget, changeColorSVG } = global.rootRequire('classes/ulti')
// const { timeConverter, rxaget, rxChangeSlug, stringToColour, idToColor ,changeColorSVG} = global.rootRequire('classes/ulti')
// const { checkNameContact, checkNameUser, parseMessageDesc } = global.rootRequire('classes/chat')
const { rxgetLocal, rxsetLocal } = global.rootRequire('classes/request')

// const workerGroup = global.rootRequire('classes/globalGroups')
const workerPolls = global.rootRequire('classes/globalPolls')
const worker = global.rootRequire('classes/globalUser')
const workerUnread = global.rootRequire('classes/globalUnread')
const chatDB = global.rootRequire('classes/indexedDB').default
const rxio = global.rootRequire('classes/socket').default

const areEqualGroup = (prevProps, nextProps) => {
  try {
    let prevGroup = prevProps.data.groups[prevProps.index]
    let nextGroup = nextProps.data.groups[nextProps.index]

    if (prevGroup.group_id !== nextGroup.group_id) {
      return false
    } else if (prevGroup.last_sort !== nextGroup.last_sort) {
      return false
    } else if (prevGroup.group_id === prevProps.data.groupIdActive || nextGroup.group_id === nextProps.data.groupIdActive) {
      return false
    } else if (prevGroup.count_unread !== nextGroup.count_unread) {
      return false
    } else if (prevGroup.group_fullname !== nextGroup.group_fullname) {
      return false
    } else if (prevGroup.another_seen_mess !== nextGroup.another_seen_mess) {
      return false
    } else if (nextGroup.type === 3 && nextGroup.partner_id && (rxaget(worker.users[nextGroup.partner_id], 'profile_url') !== nextGroup.avatar_url || rxaget(worker.users[nextGroup.partner_id], 'full_name') !== nextGroup.group_fullname)) {
      return false
    }
    return true
  } catch (e) {
    return true
  }

  /* Trả về true nếu nextProps bằng prevProps, ngược lại trả về false */
}

const newRow = React.memo(function MyComponent({ data, index, style }) {
  return <div style={style}>
    <GroupItem
      userid={data.userid}
      usertoken={data.usertoken}
      groupObj={data.groups[index]}
      groupIdActive={data.groupIdActive}
      chooseGroup={(group) => data.chooseGroup(group)}
      onRightClickGroup={(e, group) => data.onRightClickGroup(e, group)}
    />
  </div>
}, areEqualGroup);


const ListGroups = (props) => {
  let allItems = props.arrGroups
  // if (props.arrGroups.length > 0) {
  //   let arrItemsId = allItems.map(o => o.group_id)
  //   let newArr = props.arrGroups.filter(o => arrItemsId.indexOf(o.group_id) === -1)
  //   if (newArr.length > 0) {
  //     allItems = [...allItems, ...newArr]
  //   }
  // }

  return (
    <div className='zleft_contactlist' id='zgroup_list' > {allItems.length > 0 &&
      <List
        className="group_list_box"
        height={props.windowHeight}
        itemCount={allItems.length}
        itemData={{
          groups: allItems,
          groupIdActive: props.groupIdActive,
          userid: props.userid,
          usertoken: props.usertoken,
          chooseGroup: (group) => props.chooseGroup(group),
          onRightClickGroup: (e, group) => props.onRightClickGroup(e, group)
        }}
        itemSize={56}
        width={300}
        onScroll={props.handleOnscroll}
      >
        {newRow}
      </List>
    }
    </div>
  )
}


class GroupListComponent extends Component {
  _isMounted = false

  constructor(props, context) {

    super(props, context)
    this.state = {
      flagLoad: false,
      windowHeight: window.innerHeight - 150,
      groupId: '',
      tabTypeGroup: (rxgetLocal('tab_chatfolder')) ? rxgetLocal('tab_chatfolder') : '1',
      arrGroups: [],
      group: rxaget(this.props, 'rxgroup.group', {}),
      tabCnt: { total: 0, staff: 0, customer: 0 }
    }

    this.state.groupId = this.state.group.group_id

    this.groupsLength = 0
    this.maxOffset = 0
    this.pIndex = 0
    this.flagBlock = false
    this.loginFirst = false

    this.userid = rxaget(this.props, 'netaauth.user.id', '')
    this.token = rxaget(this.props, 'netaauth.user.token', '')

    this._isMounted = true

    this.loadHandleSocket()
  }


  componentDidMount() {
    this._isMounted = true
    let chatRoot = document.getElementById('chat-root');
    if (chatRoot) {
      chatRoot.addEventListener('reloadPage', (e) => {
        if (e.detail && e.detail.reload) {
          this.fetchGroups(0, 'reset')
        }
      })
    }

    // let queryListGroups = chatDB.groups.orderBy('last_sort').reverse().limit(120)

    if (['2', '3'].indexOf(this.state.tabTypeGroup) !== -1) {
      let queryListGroups = chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && oGroup.folders.indexOf(this.state.tabTypeGroup) !== -1)).reverse().limit(120)
      queryListGroups.toArray().then(arrGroupsTmp => {
        if (arrGroupsTmp.length > 0) {
          let newArrGroups = []
          try {
            for (let gTmp of arrGroupsTmp) {
              if (gTmp.occupants_uins.indexOf(this.userid.toString()) !== -1) {
                newArrGroups.push(gTmp)
              } else {
                chatDB.groups.delete(gTmp.group_id).then(result => {
                  console.log(result)
                }).catch(e => { })
              }
            }
          } catch (e) {
            newArrGroups = arrGroupsTmp
          }

          this.setState({
            arrGroups: newArrGroups,
            flagLoad: true
          })
        } else {
          this.loginFirst = true
        }
      }).catch(e => { console.log(e) })
    } else {
      chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && (oGroup.folders.indexOf('2') !== -1))).reverse().limit(120).toArray().then(arrNB => {
        chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && (oGroup.folders.indexOf('3') !== -1))).reverse().limit(120).toArray().then(arrKH => {
          let arrGroupsTmp = [...arrNB, ...arrKH].sort((a, b) => a.last_sort > b.last_sort ? -1 : 1);
          if (arrGroupsTmp.length > 0) {
            let newArrGroups = []
            try {
              for (let gTmp of arrGroupsTmp) {
                if (gTmp.occupants_uins.indexOf(this.userid.toString()) !== -1) {
                  newArrGroups.push(gTmp)
                } else {
                  chatDB.groups.delete(gTmp.group_id).then(result => {
                    console.log(result)
                  }).catch(e => { })
                }
              }
            } catch (e) {
              newArrGroups = arrGroupsTmp
            }

            this.setState({
              arrGroups: newArrGroups,
              flagLoad: true
            })
          } else {
            this.loginFirst = true
          }
        })
      })
    }


    chatDB.users.each(user => {
      if (user && user.Id) {
        worker.addUser(user.Id, user)
      }
    })

    if (this.token && this.userid) {
      if (!rxio.connected && !rxio.init_connected) {
        rxio.login(this.token, this.userid, (data) => {
          // rxio.getWaitGroup((data) => {

          //   console.log('11111111111')
          //   console.log(data)
          //   // setTimeout(() => {
          //   //   this.fetchGroups(0)
          //   // }, 2000)
          // })
        })
      }
    }

    let elemChat = document.getElementById('chat-root');
    elemChat.addEventListener('reload_page', (e) => {
      if (this.token && this.userid) {
        setTimeout(() => {
          this.fetchGroups(0)
        }, 1000)
      }
    })

    if (window && window.ipcRenderer) {
      window.ipcRenderer.on('reload_page', (event, args) => {
        let newGroup = rxaget(this.props, 'rxgroup.group', {})
        let oldGroup = this.state.group

        if (newGroup.group_id !== oldGroup.group_id) {
          this.setState({
            groupId: newGroup.group_id,
            group: newGroup
          })
        }

        if (this.token && this.userid) {
          this.chooseGroup(newGroup)
          try {
            this.fetchGroups(0)
            rxio.getWaitGroup((data) => {
              this.fetchGroups()
            })
          } catch (error) { }
        }
      })


    }

    window.addEventListener('resize', this.resize.bind(this))
    this.resize()
  }

  resize() {
    this.setState({
      windowHeight: window.innerHeight - 150
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize.bind(this))
  }


  loadHandleSocket() {
    rxio.getWaitConnect((data) => {
      if (data) {
        this._isMounted = true
        this.fetchGroups(0)

        rxio.getWaitGroup((data) => {
          if (data && data.group_id) {
            chatDB.groups.get({ group_id: data.group_id.toString() }).then(groupInDB => {
              if (!groupInDB) {

                const api_group_detail = global.rxu.config.get_groups + '/' + data.group_id
                fetch(api_group_detail, {
                  method: 'GET',
                  headers: {
                    Accept: 'application/json',
                    'TC-Token': this.token,
                    Connection: 'Keep-Alive',
                    'Accept-Encoding': 'gzip'
                  },
                  body: null
                }).then(res => res.json()).then((json) => {
                  let objUsers = []
                  if (json) {
                    if (json.users && json.users.constructor === Array && json.users.length > 0) {
                      for (const user of json.users) {
                        if (!(rxaget(user, 'full_name', '') || rxaget(user, 'phone', ''))) {
                          user.full_name = translate('Stranger')
                        }
                        worker.addUser(user.Id, { id: user.Id, uid: user.Id, ...user })
                        objUsers.push({ id: user.Id, uid: user.Id, ...user })
                      }
                    }
                    if (json.removed_users && json.removed_users.constructor === Array && json.removed_users.length > 0) {
                      for (const user of json.removed_users) {
                        worker.addUser(user.Id, { id: user.Id, uid: user.Id, ...user })
                        if (rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')) {
                          objUsers.push({ id: user.Id, uid: user.Id, ...user })
                        }
                      }
                    }
                    if (json.Group && json.Group.group_id.toString() === data.group_id.toString()) {
                      chatDB.users.bulkPut(objUsers)
                    }

                    if (data && data.folders && data.folders.constructor === Array && data.folders.length === 0) {
                      if (data.type === 2) {
                        rxio.socket.emit('update_group', { group_id: Number(data.group_id), folders: [2] })
                      }
                      if (data.type === 3) {
                        let partnerUser = json.users.filter(uObj => uObj.Id.toString() !== this.userid.toString())
                        if (partnerUser && partnerUser.constructor === Array && partnerUser.length > 0 && partnerUser[0] && partnerUser[0]['phone']) {
                          this.checkTypeUser(partnerUser[0]['phone'], data.group_id)
                        }
                      }
                    }
                    // let partnerUser = json.users.find(uObj => uObj.Id === partnerId)
                  }
                })
              }
            })
          }

          setTimeout(() => {
            this.fetchGroups()
          }, 2000)
        })

      } else {
        setTimeout(() => {
          this.loadHandleSocket()
        }, 200)
      }
    })
  }

  checkTypeUser(username, group_id) {
    if (username) {
      let api_profile = global.rxu.config.base_api_neta + '/api/users/profile/' + encodeURI(username)
      fetch(api_profile, {
        method: 'GET',
        headers: { Accept: 'application/json', 'TC-Token': this.token, Connection: 'Keep-Alive', 'Accept-Encoding': 'gzip' }
      }).then(res => res.json()).then((json) => {
        if (json.user_type && json.user_type === 1) {
          chatDB.groups.get({ group_id: group_id.toString() }).then(groupDB => {
            if (groupDB) {
              chatDB.groups.update(group_id.toString(), { folders: ['2'] }).then(o => {
                this.props.changeGroupFunc()
              }).catch(e => {
                console.log(e)
              })
            }
          })
        } else {
          rxio.socket.emit('update_group', { group_id: Number(group_id), folders: [3] }, (data) => {
            if (data && data.group && data.group.folders && data.group.folders.constructor === Array && data.group.folders.length > 0) {
              chatDB.groups.get({ group_id: group_id.toString() }).then(groupDB => {
                if (groupDB) {
                  chatDB.groups.update(group_id.toString(), { folders: ['3'] }).then(o => {
                    this.props.changeGroupFunc()
                  }).catch(e => {
                    console.log(e)
                  })
                }
              })
            }
          })
        }
      }).catch(error => {
        console.log("fetch Profile error")
      })
    }
  }

  chooseGroup(group) {
    if (this._isMounted) {
      this.props.callBackShowFooter()
      this.setState({
        groupId: group.group_id
      }, () => {
        this.fetchPollList()
        chatDB.groups.get({ group_id: group.group_id }).then(groupInDB => {
          chatDB.noti.delete(Number(group.group_id)).catch((e) => {
            // console.log(e)
          })

        }).catch((e) => {
          // console.log(e)
        })
      })
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.rxgroup && rxaget(nextProps, 'rxgroup.group.group_id', '') !== this.state.groupId && this._isMounted) {
      this.setState({
        groupId: rxaget(nextProps, 'rxgroup.group.group_id', ''),
        flagLoad: true
      })
    }
    if (rxaget(nextProps, 'rxChangeGroup.status', false) !== rxaget(this.props, 'rxChangeGroup.status', false)) {
      let tabTypeGroup = this.state.tabTypeGroup


      if (['2', '3'].indexOf(tabTypeGroup) !== -1) {
        let queryListGroups = chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && oGroup.folders.indexOf(tabTypeGroup) !== -1)).reverse().limit(120)

        queryListGroups.toArray().then(arrGroupsTmp => {

          let newArrGroupsTmp = arrGroupsTmp.filter(oGrp => oGrp.occupants_uins.indexOf(this.userid.toString()) !== -1)

          this.setState({
            arrGroups: newArrGroupsTmp
          })
        }).catch(e => { console.log(e) })
      } else {
        chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && (oGroup.folders.indexOf('2') !== -1))).reverse().limit(120).toArray().then(arrNB => {
          chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && (oGroup.folders.indexOf('3') !== -1))).reverse().limit(120).toArray().then(arrKH => {
            let newArrGroupsTmp = [...arrNB, ...arrKH].sort((a, b) => a.last_sort > b.last_sort ? -1 : 1);
            this.setState({
              arrGroups: newArrGroupsTmp
            })
          })
        })
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  handleOnscroll(scrollInfo) {
    if (!this.flagBlock && scrollInfo.scrollOffset > 200) {
      this.flagBlock = true
      setTimeout(() => {
        this.fetchGroups(this.pIndex)
      }, 1000)
    }
  }

  fetchGroupDetail(group_id) {
    chatDB.groups.get({ group_id: group_id }).then(groupInDB => {
      if (groupInDB && groupInDB.occupants_uins) {
        let occupantsUins = groupInDB.occupants_uins.map(o => Number(o)).sort()
        chatDB.users.bulkGet(occupantsUins).then(arrUserInDB => {
          arrUserInDB = arrUserInDB.filter(Boolean)
          if (arrUserInDB.length != occupantsUins.length && group_id && this.token) {
            const api_group_detail = global.rxu.config.get_groups + '/' + group_id
            fetch(api_group_detail, {
              method: 'GET',
              headers: {
                Accept: 'application/json',
                'TC-Token': this.token,
                Connection: 'Keep-Alive',
                'Accept-Encoding': 'gzip'
              },
              body: null
            }).then(res => res.json()).then((json) => {
              if (json && json.Code === 401 && json.Message === "Unauthorized") {
                try {

                } catch (e) { }
              }

              let objUsers = []

              if (json) {
                if (json.users && json.users.constructor === Array && json.users.length > 0) {
                  for (const user of json.users) {
                    if (!(rxaget(user, 'full_name', '') || rxaget(user, 'phone', ''))) {
                      user.full_name = translate('Stranger')
                    }
                    worker.addUser(user.Id, { id: user.Id, uid: user.Id, ...user })
                    objUsers.push({ id: user.Id, uid: user.Id, ...user })
                  }
                }
                if (json.removed_users && json.removed_users.constructor === Array && json.removed_users.length > 0) {
                  for (const user of json.removed_users) {
                    worker.addUser(user.Id, { id: user.Id, uid: user.Id, ...user })
                    if (rxaget(user, 'full_name', '') || rxaget(user, 'phone', '')) {
                      objUsers.push({ id: user.Id, uid: user.Id, ...user })
                    }
                  }
                }
                if (json.Group && json.Group.group_id.toString() === group_id.toString()) {
                  chatDB.users.bulkPut(objUsers)
                }
              }

              if (!groupInDB.group_fullname && groupInDB.partner_id) {
                let findUser = objUsers.find(u => u.id === Number(groupInDB.partner_id))
                if (findUser && (rxaget(findUser, 'full_name', '') || rxaget(findUser, 'phone', ''))) {
                  let group_fullname = findUser.full_name || findUser.phone
                  chatDB.groups.update(groupInDB.group_id, { group_fullname: group_fullname }).then(o => {
                    this.props.changeGroupFunc()
                  }).catch(e => { })
                }
              }


            }).catch(error => {
              console.log(error)
            })
          } else {
            try {
              if (!groupInDB.group_fullname) {
                let fullname = translate('Stranger')

                if ((groupInDB.type === 3 || groupInDB.type === 5) && rxaget(groupInDB, 'occupants_uins', []).length === 2) {
                  let userInDB = arrUserInDB.find(u => u.id === Number(groupInDB.partner_id))
                  if (userInDB) {
                    fullname = (userInDB && userInDB.name_display) ? userInDB.name_display : (userInDB.full_name) ? userInDB.full_name : (userInDB.phone) ? userInDB.phone : ''
                  }
                } else if ((groupInDB.type === 2 || groupInDB.type === 4) && groupInDB.name == '') {
                  let arrUsers = arrUserInDB.slice(3)
                  let arrNameTmp = []

                  for (let uData of arrUsers) {
                    let uName = rxaget(uData, 'full_name', '') || rxaget(uData, 'phone', '')
                    if (uName) {
                      arrNameTmp.push(uName)
                    }
                  }
                  if (arrNameTmp.length > 0) {
                    fullname = arrNameTmp.join(', ')
                  }
                }

                chatDB.groups.update(groupInDB.group_id, { group_fullname: fullname }).then(o => {
                  this.props.changeGroupFunc()
                }).catch(e => { })
              }
            } catch (e) { }
          }
        })
      }
    })
  }

  lazyFetchDetail(objGroups) {
    var i = 0;
    let maxLength = Object.keys(objGroups).length
    let myLoop = () => {
      setTimeout(() => {
        if (typeof (objGroups[i]) !== 'undefined') {
          for (let groupid of objGroups[i]) {
            this.fetchGroupDetail(groupid, () => { }, () => { })
          }
        }
        i++;

        if (i === maxLength) {
          // this.fetchPage() 
        }

        if (i < 10 && typeof (objGroups[i]) !== 'undefined') {
          myLoop();
        }
      }, 1000)
    }

    myLoop()
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async fetchGroups(pIndex, type) {
    if (rxio.connected) {
      let tabTypeGroup = this.state.tabTypeGroup
      const msg = {
        uin: this.userid,
        sort_by: 1,
        pindex: pIndex,
        psize: 30
      }

      if (tabTypeGroup && type !== 'reset') {
        msg['folder'] = Number(tabTypeGroup)
      }

      if (this._isMounted) {
        rxio.socket.emit('list_group', msg, async (data) => {
          try {
            if (data && data.groups && data.groups.constructor === Array && data.groups.length > 0) {
              let pa = []
              let objUsers = []
              let arrGroups = []
              let objGroups = {}
              let index = 1

              if (pIndex === 0) {
                try {
                  let newGroups = data.groups.map(g => Number(g.group_id))

                  let lastMin = 0
                  for (const ogroup of data.groups) {
                    let timeMess = (ogroup.last_message && ogroup.last_message.created_at) ? Number(ogroup.last_message.created_at) : (ogroup.updated_at) ? ogroup.updated_at : new Date().getTime() * 1000
                    if (lastMin > timeMess || (lastMin === 0)) {
                      lastMin = timeMess
                    }
                  }

                  let queryListGroups = chatDB.groups.orderBy('last_sort').reverse().limit(30)
                  if (['2', '3'].indexOf(tabTypeGroup) !== -1) {
                    queryListGroups = chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && oGroup.folders.indexOf(tabTypeGroup) !== -1)).reverse().limit(30)
                  }

                  let oldGroupsTmp = await queryListGroups.toArray()
                  for (let oGroup of oldGroupsTmp) {
                    if (newGroups.indexOf(Number(oGroup.group_id)) === -1 && oGroup.type === 4 && Number(oGroup.timestamp) > lastMin) {
                      chatDB.groups.delete(oGroup.group_id).then(result => {
                        this.props.changeGroupFunc()
                      }).catch(e => { })
                    }
                  }
                } catch (e2) { }
              }

              for (const ogroup of data.groups) {
                if (ogroup && ogroup.group_id && ogroup.occupants_uins.indexOf(this.userid.toString()) !== -1) {
                  let occupantsUins = ogroup.occupants_uins.map(o => Number(o)).sort()
                  let arrUserInDB = await chatDB.users.bulkGet(occupantsUins)
                  arrUserInDB = arrUserInDB.filter(Boolean)

                  ogroup.timestamp = (ogroup.last_message && ogroup.last_message.created_at) ? Number(ogroup.last_message.created_at) : (ogroup.updated_at) ? ogroup.updated_at : new Date().getTime() * 1000
                  ogroup.flagDraf = (ogroup.flagDraf) ? ogroup.flagDraf : '0' // 0 or 1
                  ogroup.flagPin = (ogroup.pinned_uins && ogroup.pinned_uins.indexOf(this.userid.toString()) !== -1) ? '1' : '0'
                  ogroup.last_sort = '1' + ogroup.flagDraf + ogroup.flagPin + ogroup.timestamp

                  try {
                    let seenListTmp = ogroup.seen_list.
                      filter(seen => (seen && seen.uin && seen.uin !== this.userid.toString() && seen.message_id !== '0')).
                      map(seen => seen.message_id).
                      sort((a, b) => b - a)

                    let mySeenLast = ogroup.seen_list.filter(seen => (seen && seen.uin && seen.uin === this.userid.toString() && seen.message_id !== '0'))
                    if (mySeenLast && mySeenLast.constructor === Array && mySeenLast.length > 0 && mySeenLast[0] && mySeenLast[0]['message_id']) {
                      ogroup.my_seen_mess = mySeenLast[0]['message_id']
                    } else {
                      ogroup.my_seen_mess = ''
                    }

                    if (seenListTmp && seenListTmp.constructor && seenListTmp.length > 0) {
                      if (!ogroup.another_seen_mess || (ogroup.another_seen_mess && Number(seenListTmp[0]) > Number(ogroup.another_seen_mess))) {
                        ogroup.another_seen_mess = seenListTmp[0]
                      }
                    } else {
                      ogroup.another_seen_mess = ''
                    }
                  } catch (e6) {
                    console.log(e6)
                  }

                  ogroup.received_list = []
                  ogroup.seen_list = []


                  const arrUins = rxaget(ogroup, 'occupants_uins', [])
                  if ((ogroup.type === 3 || ogroup.type === 5) && !ogroup.avatar_url && arrUins.length === 2) {
                    ogroup['partner_id'] = (arrUins[0].toString() === this.userid.toString()) ? arrUins[1] : arrUins[0]

                    let userInDB = await chatDB.users.get({ uid: Number(ogroup['partner_id']) })
                    if (userInDB) {
                      ogroup['group_fullname'] = (userInDB && userInDB.name_display) ? userInDB.name_display : (userInDB.full_name) ? userInDB.full_name : (userInDB.phone) ? userInDB.phone : ''

                      ogroup['avatar_url'] = userInDB.profile_url || ''
                    } else {
                      ogroup['group_fullname'] = ''
                    }

                  } else if ((ogroup.type === 2 || ogroup.type === 4) && ogroup.name == '') {
                    let arrUsers = ogroup.occupants_uins.slice(20).filter(u => u !== this.userid.toString())
                    let arrNameTmp = []

                    for (let uData of arrUserInDB) {
                      let uName = rxaget(uData, 'full_name', '') || rxaget(uData, 'phone', '')
                      if (uName) {
                        arrNameTmp.push(uName)
                      }
                    }
                    if (arrNameTmp.length > 0) {
                      ogroup['group_fullname'] = arrNameTmp.join(', ')
                    } else {
                      ogroup['group_fullname'] = ''
                    }
                  } else {
                    ogroup['partner_id'] = 0
                    ogroup['group_fullname'] = ogroup.name
                  }

                  let groupInDB = await chatDB.groups.get({ group_id: ogroup.group_id })
                  if (!groupInDB) {
                    if (Number(ogroup.unread_cnt) > 0 && (rxaget(ogroup, 'last_message.sender_uin', '').toString() !== this.userid.toString()) && Number(ogroup.unread_cnt) !== 99) {
                      ogroup.count_unread = ogroup.unread_cnt || 0
                    } else {
                      ogroup.count_unread = 0
                    }
                    ogroup.flagDetail = false
                  } else {
                    ogroup.flagDetail = ogroup.flagDetail || false
                    if (ogroup && ogroup.type !== 3 && ogroup.admin_uins && ogroup.admin_uins.constructor === Array && (ogroup.admin_uins.indexOf(this.userid.toString()) === -1 || ogroup.owner_uin.toString() !== this.userid.toString()) && ogroup.last_message && ogroup.last_message.type === 7) {
                      ogroup.last_message = groupInDB.last_message
                      ogroup.last_message_id = groupInDB.last_message_id
                      ogroup.last_sort = '1' + ogroup.flagDraf + ogroup.flagPin + groupInDB.last_message.created_at
                      ogroup.count_unread = groupInDB.count_unread || 0
                      if (groupInDB.another_seen_mess) {
                        ogroup.another_seen_mess = groupInDB.another_seen_mess
                      }
                    } else if (ogroup.last_message_id && groupInDB.last_message_id && Number(groupInDB.last_message_id) > Number(ogroup.last_message_id)) {
                      ogroup.last_message = groupInDB.last_message
                      ogroup.last_message_id = groupInDB.last_message_id
                      ogroup.last_sort = '1' + ogroup.flagDraf + ogroup.flagPin + groupInDB.last_message.created_at
                      ogroup.count_unread = groupInDB.count_unread || 0
                    } else {
                      if (Number(ogroup.unread_cnt) > 0 && (rxaget(ogroup, 'last_message.sender_uin', '').toString() !== this.userid.toString()) && Number(ogroup.unread_cnt) !== 99) {
                        ogroup.count_unread = ogroup.unread_cnt || 0
                      } else {
                        ogroup.count_unread = 0
                      }
                    }

                    if (groupInDB.my_messid_tag) {
                      ogroup.my_messid_tag = groupInDB.my_messid_tag
                    }

                    if (ogroup.timestamp && groupInDB.timestamp_call && !isNaN(ogroup.timestamp) && !isNaN(groupInDB.timestamp_call) && Number(groupInDB.timestamp_call / 1000000) > Number(ogroup.timestamp / 1000000)) {
                      ogroup.last_sort = groupInDB.last_sort_call
                      ogroup.timestamp = groupInDB.timestamp_call
                      ogroup.last_sort_call = groupInDB.last_sort_call
                      ogroup.timestamp_call = groupInDB.timestamp_call
                      if (ogroup.last_message && ogroup.last_message.created_at) {
                        ogroup.last_message.created_at = groupInDB.timestamp_call
                      }
                    }
                  }
                  this.groupsLength += 1

                  if (rxaget(ogroup, 'count_unread', 0) > 0) {
                    let typeFolder = (ogroup.folders && ogroup.folders.constructor === Array && ogroup.folders.length > 0) ? ogroup.folders[0] : '2'
                    workerUnread.initUnread(ogroup.group_id.toString(), typeFolder)
                  } else {
                    workerUnread.initUnread(ogroup.group_id.toString(), '-1')
                  }

                  if (!groupInDB) {
                    chatDB.groups.add(ogroup, ogroup.group_id.toString()).then(g => {
                      this.props.changeGroupFunc()
                    }).catch(e => { })
                  } else {
                    chatDB.groups.put(ogroup, ogroup.group_id)
                  }

                  arrGroups.push(ogroup)

                  if ([0, 1, 2].indexOf(pIndex) !== -1) {
                    if (pIndex === 0 && rxaget(ogroup, 'count_unread', 0) > 0) {
                      try {
                        let oNoti = await chatDB.noti.get(Number(ogroup.group_id))
                        if (!oNoti) {
                          await chatDB.noti.add({ group_id: Number(ogroup.group_id) })
                        }
                      } catch (e) { }
                    }

                    if (arrUserInDB.length != occupantsUins.length) {
                      let pagingName = index % 3
                      if (!objGroups[pagingName]) {
                        objGroups[pagingName] = []
                      }
                      objGroups[pagingName].push(ogroup.group_id)
                      index += 1
                    }
                  }
                }
              }

              this.props.changeGroupFunc()

              this.lazyFetchDetail(objGroups)


              if (pIndex == 0) {
                this.setState({
                  windowHeight: window.innerHeight - 150,
                  flagLoad: true
                })

              }

              let updateState = {
                arrGroups: arrGroups
              }

              if (arrGroups.length > 0) {
                updateState['flagLoad'] = true
              }

              // this.setState(updateState)

              this.pIndex += 1
              this.flagBlock = false

              if (this.loginFirst && this.pIndex <= 3) {
                await this.sleep(1000)
                this.fetchGroups(this.pIndex)
              } else {
                this.loginFirst = false
              }
            }
          } catch (e3) { }
        })
      }

    }
  }

  onRightClickGroup(e, group) {
    try {
      e.preventDefault();
      document.oncontextmenu = function (e) {
        return false;
      }

      const menuDiv = document.getElementById('context_menu-group')

      if (menuDiv) {
        menuDiv.style.top = e.clientY + 'px'
        menuDiv.style.left = Number(e.clientX) + 'px'
        menuDiv.style.display = 'block'
      }

      const menuDivMessage = document.getElementById('menu-message')
      if (menuDivMessage) {
        menuDivMessage.style.top = e.clientY + 'px'
        menuDivMessage.style.left = Number(e.clientX) + 'px'
        menuDivMessage.style.display = 'none'
      }

      this.setState({ groupChooseItem_selected: group, group: group, flagRightMouse: true, groupRightMouse: group })

    } catch (e) { }

  }

  fetchPage() {
    this.setState({
      flagLoad: false
    }, () => {
      this.setState({
        flagLoad: true
      }, () => {
        this.fetchGroups(0)
      })
    })
  }

  fetchListGroups() {
    this.setState({
      flagLoad: false
    }, () => {
      this.setState({
        flagLoad: true
      }, () => { })
    })
  }

  groupChooseItem(e, value) {
    let group_id_selected = this.state.groupChooseItem_selected.group_id
    switch (value) {
      case 'Pin a conversation':
        chatDB.groups.get({ group_id: group_id_selected }).then(ogroup => {
          if (ogroup) {
            let timestamp = ogroup.timestamp || new Date().getTime() * 1000
            let flagDraf = (ogroup.flagDraf) ? ogroup.flagDraf : '0'
            if (ogroup.pinned_uins.indexOf(this.userid.toString()) !== -1) {
              rxio.unpinGroup(group_id_selected, (data) => {
                if (data && data.result === 0) {
                  let updateGroup = {
                    timestamp: timestamp,
                    flagDraf: flagDraf,
                    flagPin: '0',
                    last_sort: '1' + flagDraf + '0' + timestamp,
                    pinned_uins: rxaget(ogroup, 'pinned_uins', []).filter(u => u.toString() !== this.userid.toString())
                  }
                  chatDB.groups.update(ogroup.group_id.toString(), updateGroup).then(o => {
                    this.props.changeGroupFunc()
                  }).catch(e => { })
                }
              })
            } else {
              rxio.pinGroup(group_id_selected, (data) => {
                let pinnedUins = ogroup.pinned_uins || []
                pinnedUins.push(this.userid.toString())
                if (data && data.result === 0) {
                  let updateGroup = {
                    timestamp: timestamp,
                    flagDraf: flagDraf,
                    flagPin: '1',
                    last_sort: '1' + flagDraf + '1' + timestamp,
                    pinned_uins: pinnedUins
                  }
                  chatDB.groups.update(ogroup.group_id.toString(), updateGroup).then(o => {
                    this.props.changeGroupFunc()
                  }).catch(e => { })
                }
              })
            }
          }
        })
        break
      case 'Chat Folder Popup':
      default:
        break

    }
  }

  leaveGroupBtnClick(groupObj) {
    let groupObjMemberIdArr = groupObj.occupants_uins
    let contactsUsers = []
    if (groupObj && groupObj.occupants_uins && groupObj.occupants_uins.constructor === Array) {
      workerUnread.initUnread(groupObj.group_id, '-1')
      if (groupObj.type === 3) {
        this.deleteGroup(groupObj)
      } else {
        this.leaveGroup(groupObj)
      }
    }
  }

  leaveGroup(groupObjTmp = null) {
    if (rxio.connected) {
      const msgUpGroup = {
        group_id: Number(groupObjTmp.group_id)
      }

      rxio.leaveGroup(msgUpGroup, (data) => {
        if (data && [0, 1].indexOf(data.result) !== -1) {
          chatDB.groups.delete(groupObjTmp.group_id).then(result => {
            this.props.changeGroupFunc()
          }).catch(e => { })
        }
      })

    }
  }

  deleteGroup(groupObj) {
    if (groupObj && groupObj.group_id) {
      if (rxio.connected) {
        const msgUpGroup = {
          group_id: Number(groupObj.group_id)
        }

        rxio.deleteConversation(msgUpGroup, (data) => {
          if (data && [0, 1].indexOf(data.result) !== -1) {
            chatDB.groups.delete(groupObj.group_id).then(result => {
              chatDB.mess.where('group_id').equals(groupObj.group_id.toString()).delete().then((deleteCount) => {
                console.log("Deleted " + deleteCount + " objects");
              })

              this.props.changeGroupFunc()
            }).catch(e => { })
          }
        })

      }
    }
  }

  chooseTypeGroup(type) {
    let tabTypeGroup = type
    let queryListGroups = chatDB.groups.orderBy('last_sort').reverse().limit(120)

    if (['2', '3'].indexOf(tabTypeGroup) !== -1) {
      queryListGroups = chatDB.groups.orderBy('last_sort').filter(oGroup => (oGroup.folders && oGroup.folders.indexOf(tabTypeGroup) !== -1)).reverse().limit(120)
    }

    queryListGroups.toArray().then(arrGroupsTmp => {
      let newArrGroups = []
      if (arrGroupsTmp.length > 0) {
        try {
          for (let gTmp of arrGroupsTmp) {
            if (gTmp.occupants_uins.indexOf(this.userid.toString()) !== -1) {
              newArrGroups.push(gTmp)
            }
          }
        } catch (e) {
          newArrGroups = arrGroupsTmp
        }
      }

      this.setState({
        arrGroups: newArrGroups,
        tabTypeGroup: type,
        flagLoad: true
      }, () => {
        rxsetLocal('tab_chatfolder', type)
        this.pIndex = 0
        this.fetchGroups(0)
      })

    }).catch(e => { console.log(e) })
  }


  changeTypeGroup(type) {
    let groupChooseItemSelected = this.state.groupChooseItem_selected
    if (groupChooseItemSelected && groupChooseItemSelected.group_id && groupChooseItemSelected.folders) {
      groupChooseItemSelected.folders = [type]
      this.setState({
        groupChooseItem_selected: groupChooseItemSelected
      }, () => {
        const msg = {
          group_id: Number(groupChooseItemSelected.group_id),
          folders: [Number(type)]
        }
        rxio.socket.emit("update_group", msg, (data) => {
          if (data && data.group && data.group.folders && data.group.folders.constructor === Array && data.group.folders.length > 0) {
            chatDB.groups.get({ group_id: groupChooseItemSelected.group_id.toString() }).then(groupInDB => {
              if (groupInDB) {
                let paramsUpdateGroup = {
                  folders: [type]
                }
                chatDB.groups.update(rxaget(groupChooseItemSelected, 'group_id', '').toString(), paramsUpdateGroup).then(o => {
                  this.props.changeGroupFunc()
                  this.setState({
                    groupChooseItem_selected: {}
                  })
                }).catch(e => {
                  console.log(e)
                })
              }
            })
          }
        })
      })
    }
  }

  fetchPollList() {
    let group_id = this.state.groupId
    let headers = { 'Accept': 'application/json', 'Content-Type': 'application/json; charset=utf-8', 'TC-Token': this.token }
    fetch(global.rxu.get(global.rxu.config, 'api_poll_list') + '?group_id=' + group_id, {
      method: 'GET',
      body: null,
      headers: headers
    })
      .then((res) => { return res.json() })
      .then((json) => {
        if (json && json.polls) {
          let pollsArr = [...json.polls]

          let objPolls = {
            group_id: group_id,
            data: pollsArr
          }
          chatDB.polls.put(objPolls, group_id)
            .catch(e => {
              console.log(e)
              alert(translate('There was an error when changing group, please logout and login into the app to use this feature'))
            })
          workerPolls.addPoll(group_id, { group_id: group_id, data: pollsArr })

          // this.setState({polls:json.polls})
          // console.log(json)
        }
      }).catch(er => console.log(er))
  }

  render() {
    let typeChatFolder = ''
    if (this.state.groupChooseItem_selected && this.state.groupChooseItem_selected.folders && this.state.groupChooseItem_selected.folders.constructor === Array && this.state.groupChooseItem_selected.folders.length > 0) {
      typeChatFolder = this.state.groupChooseItem_selected.folders[0]
    }
    return (<div>

      <TabChatFolders
        chooseTypeGroup={type => this.chooseTypeGroup(type)}
      />

      <ListGroups
        usertoken={this.token}
        userid={this.userid}
        arrGroups={this.state.arrGroups}
        windowHeight={this.state.windowHeight}
        groupIdActive={this.state.groupId}
        chooseGroup={(group) => this.chooseGroup(group)}
        handleOnscroll={(e) => this.handleOnscroll(e)}
        onRightClickGroup={(e, group) => this.onRightClickGroup(e, group)}
      />

      <div id='context_menu-group'>
        {(this.state.groupChooseItem_selected && this.state.groupChooseItem_selected.group_id) && <div className={'Rectangle-1773'}>

          {/*<div className={this.state.groupChooseItem_selected.type !== 4 ?'group-menu_item border-bottom':'className_hiden'}>
              <div className ='group-item-head'>
                <img className='group_img_item filter_img_class' src={changeColorSVG('./images/default/icons/Group 10@3x.svg')}alt=''/>
              </div>
              <div className='group-item-info' onClick={e => this.onClickShowPopup_ManageGroup()}>
                {this.state.groupChooseItem_selected.type !== 3 ? translate('Manage group') : translate('View profile')}
              </div>
            </div>*/}

          {/*<div className={this.state.groupChooseItem_selected.type !== 4 ?'group-menu_item border-bottom':'className_hiden'} onClick={e => this.groupChooseItem(e, 'Mark as read')}>
              <div className ='group-item-head'>
                <img className='group_img_item filter_img_class' src={changeColorSVG('./images/default/icons/icon-chat-readed.svg')}alt=''/>
              </div>
              <div className='group-item-info'>{translate('Mark as read')}</div>
            </div>*/}


          {/*<div className={this.state.notificationStatus === true ?'group-menu_item border-bottom':'group-menu_item_hiden'} onClick={e => this.groupChooseItem(e, 'Turn off notifications')}>
              <div className ='group-item-head'>
                <img className='group_img_item group_img_item_head filter_img_class' src={(!this.state.notificationStatus) ? changeColorSVG('./images/default/icons/icon-unnotifi.svg') : changeColorSVG('./images/default/icons/icon-notifi.svg')} alt=''/>
              </div>
              <div className='group-item-info'>{this.checkDisableNoti(this.state.groupChooseItem_selected.group_id) === true ? translate('Turn on notifications') : translate('Turn off notifications')}</div>
            </div>*/}

          <div className='chatfolder-menu_item border-bottom'>
            <div className='group-item-head'>
              <img className='group_img_item group_img_item_head filter_img_class' src={changeColorSVG('./images/default/icons/icon-folder.svg')} alt='' />
            </div>
            <div className='group-item-info'>{translate('Chat Folder')}</div>

            {/* <div className="chatfolder-item_row" onClick={e => this.changeTypeGroup('2')}>
                <div className="chatfolder-item_name"> Nội bộ </div>
                <div className="chatfolder-item_checked">
                  <label className="chatfolder-item_label">
                    {(typeChatFolder !== '2') && <span className="chatfolder-item_checkmark"></span>}
                    {(typeChatFolder === '2') && <span className="chatfolder-item_checkmark-active"></span>}
                  </label>
                </div>
              </div> */}
            {/* <div className="chatfolder-item_row" onClick={e => this.changeTypeGroup('3')}>
                <div className="chatfolder-item_name"> Khách hàng </div>
                <div className="chatfolder-item_checked">
                  <label className="chatfolder-item_label">
                    {(typeChatFolder !== '3') && <span className="chatfolder-item_checkmark"></span>}
                    {(typeChatFolder === '3') && <span className="chatfolder-item_checkmark-active"></span>}
                  </label>
                </div>
              </div> */}
          </div>

          <div className='group-menu_item border-bottom' onClick={e => this.groupChooseItem(e, 'Pin a conversation')}>
            <div className='group-item-head'>
              <img className='group_img_item group_img_item_head filter_img_class' src={(this.state.groupChooseItem_selected && this.state.groupChooseItem_selected.pinned_uins && this.state.groupChooseItem_selected.pinned_uins.indexOf(this.userid.toString()) === -1) ? changeColorSVG('./images/default/icons/icon-pin.svg') : changeColorSVG('./images/default/icons/icon-unpin.svg')} alt='' />
            </div>
            <div className='group-item-info'>{(rxaget(this.state.groupChooseItem_selected, 'pinned_uins', []).indexOf(this.userid.toString()) === -1) ? translate('Pin a conversation') : translate('Unpin a conversation')}</div>
          </div>


          <div className={rxaget(this.state.groupChooseItem_selected, 'type', 0) !== 4 ? 'group-menu_item border-bottom' : 'className_hiden'}>
            <div className='group-item-head'>
              <img className='group_img_item filter_img_class' src={(rxaget(this.state.groupChooseItem_selected, 'type', 0) !== 3) ? changeColorSVG('./images/default/icons/ic_reply.svg') : changeColorSVG('./images/default/icons/icon-delete-chat.svg')} alt='' />
            </div>
            <div className='group-item-info' onClick={e => this.leaveGroupBtnClick(this.state.groupChooseItem_selected)}>
              {(rxaget(this.state.groupChooseItem_selected, 'type', 0) !== 3) ? translate('Leave group') : translate('Delete Conversation')}
            </div>
          </div>

        </div>}


      </div>

    </div>)
  }
}

const mapStateToProps = (state, ownProps) => ({
  netaauth: state.netaauth,
  user: state.user,
  rxgroup: state.rxgroup,
  rxChangeGroup: state.rxChangeGroup
})

const mapDispatchToProps = {
  changeGroupFunc
}

const GroupListComponentWrap = connect(
  mapStateToProps,
  mapDispatchToProps
)(GroupListComponent)

export default GroupListComponentWrap